import { createContainer } from '@dbk-legacy/muster/react';

import PositionHeader from './position-header';

export const defaultPositionDataFragment = {
  security: {
    name: true,
  },
  currency: true,
  quantity: true,
  marketValue: true,

  unrealisedGL: true,
  unrealisedGLPercent: true,
};

export function factory({
  component = PositionHeader,

  positionDataFragment = defaultPositionDataFragment,
  positionDataFragmentExtend,
} = {}) {
  let resultingPositionDataFragment = positionDataFragment;

  if (positionDataFragmentExtend) {
    resultingPositionDataFragment = Object.assign(
      {},
      resultingPositionDataFragment,
      positionDataFragmentExtend
    );
  }

  return createContainer({
    $fragments: {
      uiStatic: {
        labels: true,
      },
      positionData: resultingPositionDataFragment,
      portfolio: {
        referenceCurrency: true,
      },
    },
  }, ({ uiStatic, positionData, portfolio }) => {
    const { currency, name, unrealisedGLPercent, ...rest } = positionData;

    return {
      labels: uiStatic.labels,
      position: {
        securityName: name && name,
        marketValueUnit: portfolio.referenceCurrency,
        unrealisedGLUnit: portfolio.referenceCurrency,
        unrealisedGLPercentage: unrealisedGLPercent,
        positionCurrency: currency,
        ...rest,
      },
    };
  })(component);
}

export default factory();
